<template>
  <WebsitePageLayout>
    <slot />
  </WebsitePageLayout>
</template>

<script setup></script>

<style lang="scss">
  * {
  }
</style>
